var HttpFilter = (function () {
    function HttpFilter() {
    }
    HttpFilter.prototype.intercept = function (request, next) {
        return next.handle(request);
    };
    return HttpFilter;
}());
export { HttpFilter };
